import i18next from "i18next";
import { Smooch } from 'react-native-smooch'
import { setChatInterface } from "../../Redux/Reducers/appPreservedConfigReducer";
import { setRenderInfoPopup, setRenderLoader } from "../../Redux/Actions/appConfigAction";
import { redirectToDeepLink } from "../../js/deeplink";
import { isAndroid, isWeb } from "../../utils/Helper";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getAlliantsChatLoginPromise } from "./alliantsChat";
import { ALLIANTS_CHAT, INNSPIRECHAT } from "../../config/Constant";
import { chatLogin } from "./handleChatState";

export const initializeChat = () => {
  return async (dispatch, getState) => {
    try {
      const { chatInterface } = getState().appPreservedConfigSlice;

      if(chatInterface?.interfaceKey?.toLowerCase() == INNSPIRECHAT){
        dispatch(setChatInterface({chatInitialized: true}));
      }

      if (chatInterface?.interfaceKey?.toLowerCase() === ALLIANTS_CHAT) {
        dispatch(setChatInterface({ chatInitialized: true }));
      }
    } catch (error) {
      console.log("Error while initializing chat", error);
    }
  };
};

export const handleOpenChat = () => {

  return async (dispatch, getState) => {
    try {
      const { chatInterface } = getState().appPreservedConfigSlice;

      if(chatInterface?.interfaceKey?.toLowerCase() == INNSPIRECHAT){

        // if(Platform.OS == "android"){
        //   const { PermissionsAndroid } = await import('react-native');
        //   await PermissionsAndroid.request(
        //     PermissionsAndroid.PERMISSIONS.RECORD_AUDIO
        //   );
        // }

        dispatch(setChatInterface({showConversation: true}));
      }

      if (chatInterface?.interfaceKey?.toLowerCase() === ALLIANTS_CHAT) {
        console.log("opening alliants chat");

        // Alliants chat is not supported on web — show modal
        if (isWeb()) {
          dispatch(setRenderInfoPopup(true, { title: i18next.t('featureNotAvailable_web.heading'), subtitle: i18next.t('featureNotAvailable_web.sub_heading'), onContinue: () => { redirectToDeepLink(); dispatch(setRenderInfoPopup(false)); }, primaryBtnLabel: i18next.t('featureNotAvailable_web.primary_button'), secondaryBtnLabel: i18next.t('featureNotAvailable_web.secondary_button') }));
          return;
        }

        if(isAndroid()){
          dispatch(setRenderInfoPopup(true, { title: i18next.t('featureNotAvailable_android.heading'), subtitle: i18next.t('featureNotAvailable_android.sub_heading'), secondaryBtnLabel: i18next.t('featureNotAvailable_android.secondary_button') }));
          return;
        }

        // Open chat — authenticated if login succeeded, anonymous mode otherwise
        if (!Smooch) {
          dispatch(setRenderInfoPopup(true, { title: i18next.t('featureNotAvailable.heading'), subtitle: i18next.t('featureNotAvailable.sub_heading'), onContinue: () => { redirectToDeepLink(); dispatch(setRenderInfoPopup(false)); }, primaryBtnLabel: i18next.t('featureNotAvailable.primary_button'), secondaryBtnLabel: i18next.t('featureNotAvailable.secondary_button') }));
          return;
        }

        // If background login is still in progress, wait for it before opening
        const pendingLogin = getAlliantsChatLoginPromise();
        if (pendingLogin) {
          dispatch(setRenderLoader(true, "Initializing chat..."));
          await pendingLogin;
          dispatch(setRenderLoader(false));
        }


        const appState = getState();
        const appIsLoggedIn = appState.appConfigSlice.isLoggedIn;
        const isBookingFound = appState.checkInSlice.bookingStatus.isBookingFound;
        const alreadyLoggedIn = await AsyncStorage.getItem("alliantsChatLoginInit");
        console.log("Alliants: login init on open —", alreadyLoggedIn);

        // If the app has a logged-in guest but Smooch login failed earlier, retry once
        if ((appIsLoggedIn || isBookingFound) && alreadyLoggedIn !== "true") {
          dispatch(setRenderLoader(true, "Initializing chat..."));
          await dispatch(chatLogin());
          dispatch(setRenderLoader(false));
        }

        // Open chat — authenticated if login succeeded, anonymous mode otherwise
        Smooch.show();
        dispatch(setChatInterface({ showConversation: true }));
      }
    } catch (error) {
      console.log("Error while opening chat", error);
    }
  };
};
